import axios from "../../js/project-axios.js"

const tree = () => {
    return axios.get("/asset/location/tree");
};

const add = location => {
    return axios.post("/asset/location/add", location);
};

const update = location => {
    return axios.post("/asset/location/update", location);
};

const remove = location => {
    return axios.post("/asset/location/remove", location);
};

export default {
    tree,
    add,
    update,
    remove
};